<template>
  <div class="fancy-radio-icon" :class="{ active: isActive }">
    <div class="radio">
      <font-awesome-icon icon="check" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FancyRadioIcon",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.fancy-radio-icon {
  display: inline-block;

  .radio {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #e5e7eb;
    color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 1px;
      height: 1px; // zéro cause bug on hover
      display: block;
    }
  }
  &.active {
    .radio {
      background-color: $main-color;
      color: white;

      svg {
        width: 50%;
        height: 50%;
      }
    }
  }
}

.beepiz .fancy-radio-icon.active .radio {
  background-color: $beepiz-color;
  color: black;
}
.sfr .fancy-radio-icon.active .radio {
  background-color: $sfr-color;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/FancyRadioIcon.vue